import Vue from 'vue'
import Router from 'vue-router'

Vue.use(Router)

export default new Router({
    mode: 'history',
    base: process.env.BASE_URL,
    routes: [
        {
            path: '/search/:searchQuery?',
            name: 'search-results',
            component: () => import('./views/SearchResults.vue'),
            props: true
        },{
            path: '/',
            name: 'dashboard',
            component: () => import('./views/Dashboard.vue'),
            props: true
        }, {
            path: '/about',
            name: 'about',
            component: () =>import('./views/About.vue'),
            props: true
        },{
            path: '/myaccount/:action?',
            name: 'myaccount',
            component: () => import('./views/MyAccount.vue'),
            props: true
        },{
            path: '/customers/:id?',
            name: 'customers',
            component: () =>import('./views/Customers.vue'),
            props: true,
        },{
            path: '/projects/:id?',
            name: 'projects',
            component: () =>import('./views/Projects.vue'),
            props: true
        },{
            path: '/inventory/:id?',
            name: 'inventory',
            component: () =>import('./views/Inventory.vue'),
            props: true
        },{
            path: '/quotes/:id?',
            name: 'quotes',
            component: () =>import('./views/Quotes.vue'),
            props: true
        },{
            path: '/users/:id?',
            name: 'users',
            component: () =>import('./views/Users.vue'),
            props: true
        },{
            path: '/syssettings',
            name: 'syssettings',
            component:  () =>import('./views/SysSettings.vue'),
            props: true
        },{
            path: '/lockermodules/:id?',
            name: 'lockermodules',
            component:  () =>import('./views/LockerModules.vue'),
            props: true
        },{
            path: '/lockercombinations/:id?',
            name: 'lockercombinations',
            component:  () =>import('./views/LockerCombinations.vue'),
            props: true
        },{
            path: '/revenue',
            name: 'revenue',
            component: ()=>import('./views/Revenue.vue'),
            props: true
        },{
            path: '/supportinvoicer',
            name: 'supportinvoicer',
            component: ()=>import('./views/SupportInvoicer.vue'),
            props: true
        },{
            path: '/mediapack',
            name: 'mediapack',
            component: () => import('./views/MediaPack.vue'),
            props: true
        },{
            path: '/renttoown',
            name: 'renttoown',
            component: () => import('./views/RentToOwnPricing.vue'),
            props: true
        }
    ]
})